import GaTracking from '@common/vanilla_ui/tracking/ga';
import AuthFlow from '@common/vanilla_ui/auth/authFlow';
import {
  AcademyCurriculum, Carousel, Modal, Tabs,
  WelcomeModal, LazyLoadImage, LeadDetailsModal,
  RcbBackdrop, Countdown,
} from '@common/vanilla_ui/general';
import Briefing from '@course_landing/pages/landing/briefing';
import CurriculumFlow from '@common/vanilla_ui/general/curriculumFlow';
import Fab from '@course_landing/common/fab';
import Form from '@course_landing/pages/landing/form';
import WebinarForm from '@course_landing/pages/landing/webinarForm';
import ChatFormFlow from '@course_landing/pages/landing/conversation_form';
import SectionViewTracking from
  '@course_landing/pages/landing/sectionViewTracking';
import SalesCourseForm from '@course_landing/pages/landing/salesCourseForm';
import UsCurriculum from '@scaler_landing/components/usAcademyCurriculum';
import AiCurriculum from '@ai_landing/components/curriculumFlow';
import FormScrollBehaviour from './formScrollBehaviour';

import {
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import { INTENTS, PROGRAMS } from '@common/vanilla_ui/tracking/constants';
import { getPageProgram } from '@course_landing/utils/attribution';
import { getExperimentValue } from '@course_landing/utils/experiment';

window.addEventListener('load', () => {
  LazyLoadImage.initialize();
  const program = getPageProgram();
  const formVariant = getExperimentValue('course_page_form');
  const conversationForm = document.querySelector('.conversation-form');
  const minimalLandingPageContainer = document.querySelector(
    '.minimal-landing-page__container',
  );

  if (program === 'sales_course') {
    SalesCourseForm.initialize();
  } else if (formVariant === 'chat_form') {
    new ChatFormFlow(conversationForm);
  } else {
    Form.initialize();
  }
  WebinarForm.initialize();

  const downloadCurriculumButton = document.getElementById(
    'download_curriculum',
  );

  const academyCurriculumEls = document.querySelectorAll(
    '.curriculum__course-details',
  );

  const curriculumEls = document.querySelectorAll(
    '.course-curriculum',
  );

  const aiMlCurriculum = document.querySelectorAll(
    '.curriculum__ai-ml',
  );

  if (aiMlCurriculum.length) {
    AiCurriculum.initialize();
  } else if (curriculumEls.length) {
    CurriculumFlow.initialize();
  }

  if (academyCurriculumEls.length) {
    AcademyCurriculum.initialize();
  }

  UsCurriculum.initialize();

  Briefing.initialize();

  Carousel.initialize(
    '.people-list-glider',
    'people-list-carousel-parent',
    'dots',
    'glider-prev',
    'glider-next',
    4,
    4,
    1,
    false,
    2,
    2,
    1,
  );

  Carousel.initialize(
    '.people-mentor-glider',
    'people-mentor-carousel-parent',
    'dots',
    'glider-prev-mentor',
    'glider-next-mentor',
    4,
    4,
    1,
    false,
    2,
    2,
    1,
  );
  const eventChecker = document.getElementById('events-card');

  if (eventChecker) {
    Carousel.initialize(
      '.events-list-glider',
      'events-list-carousel-parent',
      'dots',
      'glider-prev-events',
      'glider-next-events',
      3,
      2,
      1,
      false,
      2,
      2,
      1,
    );
  }

  Modal.initialize();
  Tabs.initialize();
  WelcomeModal.initialize();
  Fab.initialize();
  Countdown.initialize();
  LeadDetailsModal.initialize();
  SectionViewTracking.initialize([
    'briefing-v2',
  ]);
  FormScrollBehaviour.initialize();
  if (document.getElementById('auth-modal')) {
    new AuthFlow('auth-modal', 0);
  }

  const params = new URLSearchParams(window.location.search);
  if (params) {
    const forceModalOpen = params.get('forceModalOpen');
    const target = params.get('target');
    if (forceModalOpen === '1' && target !== '') {
      Modal.open(target);
    }
  }

  const appliedButton = document.querySelector('.applied-button');
  const modal = document.getElementById('data-science-intake-modal');
  if (appliedButton) {
    appliedButton.addEventListener('click', () => {
      modal.classList.add('sr-modal--open');
    });
  }

  const callBackWidget = document.getElementById('call-back');
  if (callBackWidget) {
    callBackWidget.addEventListener('click', () => {
      const phoneWidget = document.getElementById('phone-widget');
      const widgetIcon = document.getElementById('widget-icon');
      phoneWidget.click();
      widgetIcon.click();
    });
  }

  GaTracking.initialize('scaler-courses');

  const accordionTriggers = document.querySelectorAll(
    '[data-action="accordion-toggle"]',
  );
  if (accordionTriggers && accordionTriggers.length !== 0) {
    accordionTriggers.forEach(
      // eslint-disable-next-line max-len
      el => (el.getAttribute('data-target') !== 'faq-section-1'
            && !el.classList.contains('curriculum-mobile__heading')
        ? el.click() : null),
    );
  }
  if (downloadCurriculumButton) {
    downloadCurriculumButton.addEventListener('click', () => {
      setAttribution(
        INTENTS.DOWNLOAD_CURRICULUM,
        {
          program: PROGRAMS.SOFTWARE_DEVELOPMENT,
        },
      );
    });
  }

  if (!minimalLandingPageContainer) {
    RcbBackdrop.initialize({
      elements: [
        '#main-site-header',
        '.course-page-container',
        '.footer',
        '#request-callback-strip',
      ],
    });
  }
});
